<template>
  <el-row class="species-navigation-item" :class="store.species.current === id ? 'active' : 'inactive'">
    <el-col :span="3" :offset="1" style="padding-top: 3px;">
      {{ index }}
    </el-col>
    <el-col :span="16" style="padding-top: 3px; cursor: pointer;" @click.native="handleNameClick">
      <span style="margin-right: 5px;">{{ OrganismName }}</span>
    </el-col>
    <el-col :span="4" style="text-align: center;">
      <el-button size="mini" :plain="true" @click="handleRemove">X</el-button>
    </el-col>
  </el-row>
</template>

<script>
import { store } from '../scripts/store.js'

const _ = require('lodash')
export default {
  name: 'SpeciesNavigationItem',
  props: {
    index: Number,
    id: String
  },
  data () {
    return {
      store: store
    }
  },
  computed: {
    OrganismName () {
      const context = this
      return _.find(store.species.list, s => {
        return s.MSDBID === context.id
      }).OrganismName
    }
  },
  methods: {
    handleNameClick () {
      store.setCurrentSpecies(this.id, 'SpeciesNavigationItem')
    },
    handleRemove () {
      const context = this
      const row = _.find(store.species.list, s => {
        return s.MSDBID === context.id
      })
      store.removeSpecies(row, 'SpeciesNavigationItem')
    }
  }
}
</script>

<style>
.species-navigation-item {
  text-align: left;
  margin: 10px;  
  font-family: 'Oxygen', Arial, Helvetica, sans-serif;
}

.species-navigation-item.active {
  color: white;
  background-color: #324157;
  border-radius: 5px;
}
</style>
